import gsap from 'gsap'
import { useEffect, useRef, useState } from 'react'
import capVector from '../../assets/images/capVector.svg'
import handVector from '../../assets/images/handVector.svg'
import healthVector from '../../assets/images/healthVector.svg'
import heartVector from '../../assets/images/heartVector.svg'
import homeVector from '../../assets/images/homeVector.svg'
import leafVector from '../../assets/images/leafVector.svg'
import leftArrow from '../../assets/images/leftarrow2.svg'
import phoneVector from '../../assets/images/phoneVector.svg'
import rightArrow from '../../assets/images/rightarrow.svg'
import { Link } from 'react-router-dom'


const OurServices = () => {
  const [active, setActive] = useState(0);
  const prevActiveRef = useRef(active);

  //left right arrow scaling
  useEffect(() => {
    gsap.to('.arrow-container', {
      scale: 1.5,
      opacity: 1,
      duration: 2,
      ease: "power4.inOut",
      repeat: -1,
      yoyo: true,
      yoyoEase: 'power4.inOut'
    });
  }, []);

  //small circle fade in fade out
  useEffect(() => {
    gsap.fromTo(
      '.left-1-circle',
      { opacity: 0.7, duration: 1.5, ease: 'power1.inOut' },
      { opacity: 1, duration: 1.5, ease: 'power1.inOut' }
    );
    gsap.fromTo(
      ['.left-1-circle-text'],
      { opacity: 0, duration: 1.5, ease: 'power1.inOut' },
      { opacity: 1, duration: 1.5, ease: 'power1.inOut' }
    );
    gsap.fromTo(
      ['.inner-2'],
      { opacity: 0.1, duration: 1.2, ease: 'power2.in' },
      { opacity: 1, duration: 1.0, ease: 'power2.in' }
    );
    gsap.to(".play", {
      scale: 1,
      duration: 1.5,
      ease: "power1.inOut",
      yoyo: true,
      repeat: -1,
    })
    const prevActive = prevActiveRef.current; // previous value

    // this will update ref for the next render
    prevActiveRef.current = active;

    console.log("last", prevActive)
    console.log("active", active)
    if (((prevActive < active) && !(prevActive === 0 && active === 6)) || (prevActive === 6 && active === 0)) {
      gsap.fromTo(
        '.top-circle-hidden-left',
        {
          x: '0',
          opacity: 0
        },
        {
          x: '-320',
          opacity: 0,
          duration: 0.8,
          ease: 'power1.inOut'
        }
      );

      gsap.to(
        '.top-circle', {
        x: '-320',
        opacity: 0,
        duration: 0.8,
        ease: 'power1.inOut'
      })
      gsap.fromTo('.top-circle-hidden-right', {
        x: '0',
        opacity: 0,
        duration: 0.8,
        ease: 'power1.inOut'
      },
        {
          x: '-320',
          opacity: 1,
          duration: 0.8,
          ease: 'power1.inOut'
        })

    } else if ((prevActive > active) || (prevActive === 0 && active === 6)) {
      gsap.fromTo(
        '.top-circle-hidden-left', {
        x: '0',
        opacity: 0,
        duration: 1,
        ease: 'power2.inOut'
      }, {
        x: '320',
        opacity: 1,
        duration: 1,
        ease: 'power2.inOut'
      })
      gsap.to(
        '.top-circle', {
        x: '320',
        opacity: 0,
        duration: 1,
        ease: 'power2.inOut'
      })
      gsap.fromTo(
        '.top-circle-hidden-right',
        {
          x: '0',
          opacity: 0
        },
        {
          x: '320',
          opacity: 0,
          duration: 1,
          ease: 'power2.inOut'
        }
      );
    } else {
      gsap.set(['.top-circle'], {
        x: 0
      })
      gsap.set(['.top-circle-hidden-right', '.top-circle-hidden-left'], {
        x: 0, opacity: 0
      })
    }


  }, [active]);

  //limited carousel movement
  // const carouselMoveNext = () => {
  //     if (active < carouselArray.length - 1) {
  //         setActive(active + 1);
  //     }
  // }
  // const carouselMovePrev = () => {
  //     if (active > 0) {
  //         setActive(active - 1);
  //     }
  // }

  //full carousel movement
  const carouselMoveNext = () => {
    setActive((active + 1) % carouselArray.length);
  }

  const carouselMovePrev = () => {
    setActive((active - 1 + carouselArray.length) % carouselArray.length);
  }

  const getSmallCircleTitle = (offset) => {
    const totalCircles = carouselArray.length;
    const currentIndex = (active + offset + totalCircles) % totalCircles;
    return carouselArray[currentIndex].title;
  };

  // Button Text Roll
  const handleMouseEnter = (e) => {
    const button = e.currentTarget;
    const visibleSpan = button.querySelector(".btn1");
    const hiddenSpan = button.querySelector(".btn2");

    gsap.to(visibleSpan, {
      duration: 1,
      y: -100,
      ease: "power2.inOut",
    });
    gsap.to(hiddenSpan, {
      duration: 1.5,
      y: -50,
      ease: "power2.inOut",
      opacity: 1,
    });
  };

  const handleMouseLeave = (e) => {
    const button = e.currentTarget;
    const visibleSpan = button.querySelector(".btn1");
    const hiddenSpan = button.querySelector(".btn2");

    gsap.to(visibleSpan, {
      duration: 0.5,
      y: 0,
      ease: "power2.inOut",
    });
    gsap.to(hiddenSpan, {
      duration: 1,
      y: 0,
      ease: "power2.inOut",
      opacity: 0,
    });
  };
  const carouselArray = [
    {
      id: 1,
      name: "Param Consulting Services",
      title: "IT Consulting",
      img: phoneVector,
      content:
        "Founded in 2001, Param Consulting Services, India. aims to solve all IT-related requirements of clients. Be it application development, training, or project management; PCSI is one roof that covers it all. Param Consulting offers cost-effective and value-driven IT solutions to clients looking forward to inducing technology in regular business activities. With the state of the art technology, the company guarantees a comprehensive solution to all your managerial needs.",
      url: "https://paramgroups.in/",
    },
    {
      id: 2,
      name: "BB Thakar Research & Development Center",
      title: "R & D",
      img: handVector,
      content: `Research & Development focuses on developing natural treatments for chronic diseases through innovative drug testing. With a dedicated team, we integrate science and wellness to improve healthcare solutions for conditions like Alzheimer's and diabetes.`,
      url: "https://drbbthakar.com/",
    },
    {
      id: 3,
      name: "Param Academy",
      title: "Education",
      img: capVector,
      content:
        "Param Academy is an advanced training and education service provider with a strong presence in the industry for over two decades.The academy aims to become the torchbearer for all students and professionals pursuing their careers in diverse fields, including healthcare, technology, and business.",
      url: "https://academy.paramgroups.com/",
    },
    {
      id: 4,
      name: "Param Adult Day Care",
      title: "Adult Day Care",
      img: homeVector,
      content:
        "Param Adult Day Care is a Not-for-profit organization helping senior citizens a comfortable road in their second innings of life. The foundation of the company is to build a healthier community by offering a safe, friendly, and fun environment to the aging population. Family caregivers trust us because we offer a homely environment and the best healthcare services in the area.",
      url: "https://www.paramadultdaycares.com/",
    },
    {
      id: 5,
      name: "Param Wellness",
      title: "Wellness",
      img: leafVector,
      content:
        "Param Wellness is a blend of healthcare and wellness service provider using Ayurveda and Natural body healing. This US-based organization focuses on refreshing, restoring, and rejuvenating the mind, body, and spirit naturally with the action. The company’s motto is to improve the quality of life of individuals using complementary healing approaches along with conventional treatments.",
      url: "https://paramwellness.com/",
    },
    {
      id: 6,
      name: "Param Care Foundation",
      title: "Care Foundation",
      img: heartVector,
      content:
        "Param Care Foundation, a charitable organization founded in New Jersey to actively improve healthy living in the community. The foundation envisions making society aware of the everyday decisions that make them one step closer to their healthcare goal. The association conducts seminars, yoga sessions, and healthcare screenings to connect with the community and motivate them to improve their lifestyle.",
      url: "https://paramcare.org/",
    },
    {
      id: 7,
      name: "Param Healthcare Services",
      title: "Healthcare Services",
      img: healthVector,
      content:
        "With Science on one hand and healthcare on the other, Param Bhakti Healthcare and Research is a research organization dealing in novel drug testing and development. The organization’s vision is to find natural medicinal treatments for people to cure their chronic lifestyle diseases. Inspired by B. B. Thakar, the association aims to use innovation in offering healthy growth in life.",
      url: "https://paramhealthcareservices.com/",
    },
  ];


  return (
    // Main container
    <div className="w-full flex justify-center overflow-hidden">
      {/* Container inner */}
      <div className=" xl:w-[96%] 2xl:w-[85%] lg:w-[110%] md:w-[90%] sm:w-[90%] xs:w-[100%] flex flex-col justify-center items-center gap-[10px]">
        {/* Our Services Text */}
        <div className="w-full flex flex-col text-center  font-faustina animate-zoomIn md:py-[60px] xs:py-[32px]">
          <h2 className="lg:text-[56px] xs:text-[clamp(40px,5.8vw,56px)] font-semibold bg-gradient-to-r from-[#1FA2FF] from-[40%] via-cyan-300 via-50% to-[#A6FFCB] to-60% text-transparent bg-clip-text lg:mb-[16px] md:mb-[24px] xs:mb-[16px]">
            Our Core Services
          </h2>
          <p className="1920:text-[20px] lg:text-[18px] xs:text-[16px] font-normal text-white">
            Explore The World Of Technology With Us. Come Find Your Hidden
            Competencies
          </p>
          <p className="1920:text-[20px] lg:text-[18px]  xs:text-[16px] font-normal text-white">
            By Kick-Starting Your Business With New Insights
          </p>
        </div>

        {/* carousel container */}
        <div className="w-full flex flex-col ">
          {/* Carousel 1 */}
          {carouselArray?.map((item, i) => {
            if (i !== active) return null;

            return (
              <div
                className="w-full 2xl:h-[1281px] xl:h-[1245px] lg:h-[1106px] md:h-[1281px] sm:h-[700px] 500:h-[750px] 428:h-[800px] 380:h-[860px] xs:h-[950px] flex justify-center md:pt-[125px] sm:pt-0 relative"
                key={item.id}
              >
                {/* Main circle */}
                <div className="main-circle 2xl:w-[80%] xl:w-[89%] 1150:w-[80%] lg:w-[85%] md:w-[96%] lg:h-[100%] md:h-[78%] sm:w-[100%] xs:w-[100%] 700:h-[700px] 600:h-[700px] 500:h-[600px] 428:h-[720px] 380:h-[830px] xs:h-[930px] px-1 pt-1 md:bg-gradient-to-r from-[#1FA2FF] from-[35%] via-cyan-300 via-50% to-[#A6FFCB] to-90% sm:bg-none xs:bg-none">
                  <div className="main-circle w-full md:h-full 700:h-[900px] 500:h-[900px] 428:h-[980px] 380:h-[990px] xs:h-[1120px] md:bg-black flex justify-center items-center">
                    {/* main circle inner */}
                    <div className="flex lg:w-[60%] xl:w-[65%] 2xl:w-[60%] md:w-[69%] sm:w-[100%] xs:w-[84%] 1200:gap-[48px] md:gap-[40px] xs:gap-[24px]  justify-center items-center">
                      <div className="static arrow-container h-full lg:w-[65px]  md:w-[55px] xs:w-[40px] flex items-center ">
                        <div className="left-arrow rounded-[6px] bg-gradient-to-r from-[#1FA2FF] from-[30%] via-[#12D8FA] via-50% to-[#A6FFCB] to-100% p-[2px] lg:h-[50px] md:h-[40px] xs:h-[30px] w-full">
                          <div
                            className="bg-black w-full h-full rounded-[6px]  flex justify-center items-center cursor-pointer play"
                            onClick={carouselMovePrev}
                          >
                            <img
                              src={leftArrow}
                              alt=""
                              className="play w-4 h-4"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Content inside main circle */}
                      <div className="inner-2 w-full flex flex-col justify-center md:gap-0 xs:gap-[8px]  xl:mt-1 lg:mt-[144px] md:mt-[20%]">
                        <div className="vector-img-div w-full md:h-[90px] sm:h-[80px] xs:h-[50px] flex justify-center">
                          {/* img */}
                          <img
                            src={item?.img}
                            alt=""
                            className="1200:w-[60px] lg:w-[50px] md:w-[40px]"
                          />
                        </div>
                        <div className="carousel-text w-full h-full flex flex-col text-center xl:gap-[32px] 1200:gap-[24px] xs:gap-[20px] text-white">
                          {/* name */}
                          <p className="font-[Faustina] xl:text-[40px] lg:text-[32px] xs:text-[clamp(18px,3vw,32px)] font-semibold">
                            {item?.name}
                          </p>
                          {/* content */}
                          <p className="font-[Faustina] 1200:text-[20px] 900:text-[18px] 600:text-[16px] xs:text-[14px]  font-normal md:leading-10 sm:leading-7 xs:leading-6">
                            {item?.content}
                          </p>
                          {/* button */}
                          <div className="w-full flex justify-center items-center">
                            <div className="flex justify-center items-center w-[155px] sm:w-[180px] h-[62px] sm:h-[55px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                              <Link
                                className="button-main bg-black uppercase w-full h-full rounded-[14px] font-poppins font-medium text-[14px] diagonal  text-center relative py-[16px] sm:py-[14px] px-[52px] sm:px-[45px]"
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                to={item.url}
                                target='_blank'
                              >
                                <span className="btn1 absolute transition-all top-0 left-0 w-full h-full flex justify-center items-center text-white md:text-[20px] xs:text-[18px]">
                                  Learn more
                                </span>
                                <span className="btn2 absolute tranistion-all opacity-0 top-[50px] sm:top-[50px] left-0 w-full h-full flex justify-center items-center text-white md:text-[20px] xs:text-[18px]">
                                  Learn more
                                </span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="arrow-container h-full lg:w-[65px] md:w-[55px] xs:w-[40px] flex items-center  md:mt-0 ">
                        <div className="right-arrow rounded-[6px] bg-gradient-to-l from-[#1FA2FF] from-[30%] via-[#12D8FA] via-50% to-[#A6FFCB] to-100% p-[2px] lg:h-[50px] md:h-[40px] xs:h-[30px] w-full">
                          <div
                            className="bg-black w-full h-full rounded-[6px]  flex justify-center items-center cursor-pointer play"
                            onClick={carouselMoveNext}
                          >
                            <img src={rightArrow} alt="" className="play w-4 h-4" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="absolute"></div>
                </div>

                {/* Top circle */}
                <div className="top-circle absolute top-0 left-1/5 bg-gradient-to-r from-[#1FA2FF] from-[25%] via-cyan-300 via-70% to-[#A6FFCB] to-100% lg:h-[263px] lg:w-[263px] md:h-[210px] md:w-[210px] xs:h-[163px] xs:w-[163px] rounded-[50%] p-1 xs:mt-2 md:mt-8 lg:mt-0">
                  <div className="top-circle-inner w-full h-full bg-black rounded-[50%] flex justify-center items-center">
                    <div className="top-circle-text w-[80%] h-[70%] p-4 flex justify-center items-center">
                      <p className="font-[Faustina] lg:text-[40px] md:text-[32px] xs:text-[24px] font-bold text-white text-center">
                        {item?.title}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Top circle hidden on right using calc */}
                <div className="top-circle-hidden-right absolute top-0 lg:left-[calc(50%+191px)] md:left-[calc(50%+217px)] xs:left-[calc(50%+240px)] bg-gradient-to-r from-[#1FA2FF] from-[25%] via-cyan-300 via-70% to-[#A6FFCB] to-100% md:h-[210px] md:w-[210px] lg:h-[263px] lg:w-[263px] xs:h-[163px] xs:w-[163px] rounded-[50%] p-1 xs:mt-0 md:mt-8 lg:mt-0">
                  <div className="top-circle-inner w-full h-full bg-black rounded-[50%] flex justify-center items-center">
                    <div className="top-circle-text w-[80%] h-[70%] p-4 flex justify-center items-center">
                      <p className="font-[Faustina] lg:text-[40px] md:text-[32px]  xs:text-[24px] font-bold text-white text-center flex items-center justify-center">
                        {item?.title}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Top circle hidden on left using calc */}
                <div className="top-circle-hidden-left absolute top-0  md:left-[calc(50%-423px)] lg:left-[calc(50%-453px)] xs:left-[calc(50%-401px)] bg-gradient-to-r from-[#1FA2FF] from-[25%] via-cyan-300 via-70% to-[#A6FFCB] to-100% md:h-[210px] md:w-[210px] xs:h-[163px] lg:h-[263px] lg:w-[263px] xs:w-[163px] rounded-[50%] p-1 xs:mt-24 md:mt-8 lg:mt-0">
                  <div className="top-circle-inner w-full h-full bg-black rounded-[50%] flex justify-center items-center">
                    <div className="top-circle-text w-[80%] h-[70%] p-4 flex justify-center items-center">
                      <p className="font-[Faustina] lg:text-[40px] md:text-[32px] xs:text-[24px] font-bold text-white text-center flex items-center justify-center">
                        {item?.title}
                      </p>
                    </div>
                  </div>
                </div>

                {/* small gradient vertical line */}
                <div className="gradient-vertical absolute md:top-[239px] lg:top-[263px] xs:top-[168px] md:left-[50%] sm:left-[50%] h-[34px] w-1 bg-gradient-to-b from-[#1FA2FF] from-[5%] via-cyan-300 via-70% to-[#A6FFCB] to-100%"></div>

                {/* Left Mini-Circle */}
                <div className="absolute xs:top-[195px] lg:top-[297px] md:top-[270px] left-1/2 transform -translate-x-1/2 flex items-center">
                  {/* Left Mini-Circle */}
                  <div className="w-[10px] h-[10px] rounded-full bg-gradient-to-r from-[#1FA2FF] via-cyan-300 to-[#A6FFCB]"></div>
                  {/* Dynamic Line */}
                  <div className="lg:w-[calc(313px-60px)] md:w-[180px] sm:w-[200px] xs:w-[170px] h-1 bg-gradient-to-r from-[#1FA2FF] via-cyan-300 to-[#A6FFCB]"></div>
                  {/* Right Mini-Circle */}
                  <div className="w-[10px] h-[10px] rounded-full bg-gradient-to-r from-[#1FA2FF] via-cyan-300 to-[#A6FFCB]"></div>
                </div>

                {/* left-1-circle */}
                <div className="hidden md:block left-1-circle absolute 2200:top-[11%] 2200:left-[22%] 1920:top-[11%] 1920:left-[21%] 1800:top-[11%] 1800:left-[20%] 2xl:top-[11%] 2xl:left-[19%] 1300:top-[11%] 1300:left-[17%] xl:top-[11%] xl:left-[16%] lg:top-[18.5%] lg:left-[11%] 900:top-[16%] 900:left-[6%] 800:top-[18%] 800:left-[4%] md:top-[19%] md:left-[3%] bg-gradient-to-r from-[#1FA2FF] from-[25%] via-cyan-300 via-70% to-[#A6FFCB] to-100% lg:h-[195px] lg:w-[195px] md:h-[142px] md:w-[142px] rounded-[50%] p-1">
                  <div
                    className="left-1-circle-inner w-full h-full bg-black rounded-[50%] flex justify-center items-center cursor-pointer"
                    onClick={carouselMovePrev}
                  >
                    <div className="left-1-circle-text w-[80%] h-[70%]">
                      <p className="font-[Faustina] lg:text-[24px] md:text-[18px] xs:text-[24px] font-medium text-white text-center flex justify-center items-center w-full h-full">
                        {getSmallCircleTitle(6)}
                      </p>
                    </div>
                  </div>
                </div>

                {/* left-2-circle */}
                <div className="hidden md:block left-2-circle absolute 2200:top-[32%] 2200:left-[8%] 1920:top-[31%] 1920:left-[7%] 1800:top-[32%] 1800:left-[7%] 2xl:top-[31%] 2xl:left-[6%] xl:top-[32%] xl:left-[2%] 1150:top-[50%] 1150:left-[3%] lg:top-[50%] lg:left-[1%] 900:top-[40%] 900:left-[-4%] 800:top-[40%] 800:left-[-5%] md:top-[40%] md:left-[-6%] bg-gradient-to-r from-[#1FA2FF] from-[25%] via-cyan-300 via-70% to-[#A6FFCB] to-100% lg:h-[195px] lg:w-[195px] md:h-[142px] md:w-[142px] rounded-[50%] p-1">
                  <div className="left-1-circle-inner w-full h-full bg-black rounded-[50%] flex justify-center items-center">
                    <div className="left-1-circle-text w-[80%] h-[70%]">
                      <p className="font-[Faustina] lg:text-[24px] md:text-[18px] xs:text-[24px] font-medium text-white text-center flex justify-center items-center w-full h-full">
                        {getSmallCircleTitle(5)}
                      </p>
                    </div>
                  </div>
                </div>

                {/* left-3-circle */}
                <div className="hidden md:block left-3-circle absolute 2200:top-[60%] 2200:left-[8%] 1800:top-[60%] 1800:left-[6%] 2xl:top-[60%] 2xl:left-[5%] xl:top-[60%] xl:left-[1%] lg:top-[80%] lg:left-[15%] 900:top-[65%] 900:left-[10%] 800:top-[65%] 800:left-[9%] md:top-[62%] md:left-[4%]  bg-gradient-to-r from-[#1FA2FF] from-[25%] via-cyan-300 via-70% to-[#A6FFCB] to-100% lg:h-[195px] lg:w-[195px] md:h-[142px] md:w-[142px] rounded-[50%] p-1">
                  <div className="left-1-circle-inner w-full h-full bg-black rounded-[50%] flex justify-center items-center">
                    <div className="left-1-circle-text w-[80%] h-[70%]">
                      <p className="font-[Faustina] lg:text-[24px] md:text-[18px] xs:text-[24px] font-medium text-white text-center flex justify-center items-center w-full h-full">
                        {getSmallCircleTitle(4)}
                      </p>
                    </div>
                  </div>
                </div>

                {/* right-1-circle */}
                <div className="hidden md:block left-1-circle absolute 1920:top-[11%] 1920:right-[22%] 1800:top-[11%] 1800:right-[20%] 2xl:top-[11%] 2xl:right-[19%] xl:top-[10%] xl:right-[17%] lg:top-[18%] lg:right-[12%] 900:top-[15%] 900:right-[8%] 800:top-[17%] 800:right-[5%] md:top-[18%] md:right-[1%]  bg-gradient-to-r from-[#1FA2FF] from-[25%] via-cyan-300 via-70% to-[#A6FFCB] to-100% lg:h-[195px] lg:w-[195px] md:h-[142px] md:w-[142px] rounded-[50%] p-1 cursor-pointer">
                  <div
                    className="left-1-circle-inner w-full h-full bg-black rounded-[50%] flex justify-center items-center"
                    onClick={carouselMoveNext}
                  >
                    <div className="left-1-circle-text w-[80%] h-[70%]">
                      <p className="font-[Faustina] lg:text-[24px] md:text-[18px] xs:text-[24px] font-medium text-white text-center flex justify-center items-center w-full h-full">
                        {getSmallCircleTitle(1)}
                      </p>
                    </div>
                  </div>
                </div>

                {/* right-2-circle */}
                <div className="hidden md:block right-2-circle absolute 2200:top-[30%] 2200:right-[9%] 1920:top-[30%] 1920:right-[8%] 1800:top-[31%] 1800:right-[7%] 2xl:top-[30%] 2xl:right-[7%] xl:top-[32%] xl:right-[2%] lg:top-[50%] lg:right-[2%] 900:top-[40%] 900:right-[-4%] 800:top-[40%] 800:right-[-5%] md:top-[40%] md:right-[-6%] bg-gradient-to-r from-[#1FA2FF] from-[25%] via-cyan-300 via-70% to-[#A6FFCB] to-100% lg:h-[195px] lg:w-[195px] md:h-[142px] md:w-[142px] rounded-[50%] p-1">
                  <div className="left-1-circle-inner w-full h-full bg-black rounded-[50%] flex justify-center items-center">
                    <div className="left-1-circle-text w-[80%] h-[70%]">
                      <p className="font-[Faustina] lg:text-[24px] md:text-[18px] xs:text-[24px] font-medium text-white text-center flex justify-center items-center w-full h-full">
                        {getSmallCircleTitle(2)}
                      </p>
                    </div>
                  </div>
                </div>

                {/* right-3-circle */}
                <div className="hidden md:block right-3-circle absolute 2200:top-[60%] 2200:right-[8%] 1800:top-[60%] 1800:right-[7%] 2xl:top-[60%] 2xl:right-[5%] xl:top-[60%] xl:right-[1%] lg:top-[80%] lg:right-[15%] 900:top-[65%] 900:right-[10%] 800:top-[65%] 800:right-[9%] md:top-[62%] md:right-[4%] bg-gradient-to-r from-[#1FA2FF] from-[25%] via-cyan-300 via-70% to-[#A6FFCB] to-100% lg:h-[195px] lg:w-[195px] md:h-[142px] md:w-[142px] rounded-[50%] p-1">
                  <div className="left-1-circle-inner w-full h-full bg-black rounded-[50%] flex justify-center items-center">
                    <div className="left-1-circle-text w-[80%] h-[70%]">
                      <p className="font-[Faustina] lg:text-[24px] md:text-[18px] xs:text-[24px] font-medium text-white text-center flex justify-center items-center w-full h-full">
                        {getSmallCircleTitle(3)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {/* <div className="h-[250px] sm:h-[220px] bg-black -mt-[120px] sm:-mt-[100px] w-full z-10"></div> */}
        {/* {active == 2 && <p className='text-red-400'>TEstt 2</p>}
    {active == 1 && <p className='text-red-400'>TEstt ------------- 2</p>} */}
      </div>
    </div>
  );
}

export default OurServices
